import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-close-square',
  imports: [],
  templateUrl: './icon-bold-close-square.component.html',
})
export class IconBoldCloseSquareComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24';
}
